module.exports = __webpack_public_path__ + "img/qrcode.bb749d21.svg";